const ACCESS_KEY = "session_access_token";
const REFRESH_KEY = "session_refresh_token";

let accessToken: string | null = null;
let refreshToken: string | null = null;

export function setStorageBackend(storage: any) {
  // Web版では何もしない
}

export async function initSessionTokens(): Promise<void> {
  // SSR対策
  if (typeof localStorage === 'undefined') return;
  
  accessToken = localStorage.getItem(ACCESS_KEY);
  refreshToken = localStorage.getItem(REFRESH_KEY);
}

export async function setSessionTokens(tokens: { access_token: string; refresh_token: string }): Promise<void> {
  accessToken = tokens.access_token;
  refreshToken = tokens.refresh_token;

  if (typeof localStorage !== 'undefined') {
    localStorage.setItem(ACCESS_KEY, tokens.access_token);
    localStorage.setItem(REFRESH_KEY, tokens.refresh_token);
  }
}

export async function clearSessionTokens(): Promise<void> {
  accessToken = null;
  refreshToken = null;

  if (typeof localStorage !== 'undefined') {
    localStorage.removeItem(ACCESS_KEY);
    localStorage.removeItem(REFRESH_KEY);
  }
}

export function getAccessToken(): string | null {
  return accessToken;
}

export function getRefreshToken(): string | null {
  return refreshToken;
}